"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonDivisor = exports.Buttons = exports.Description = exports.Title = exports.Icon = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.div `
  ${({ theme, sizeHeight, small }) => `
    background-color: ${theme.colors.build.light.dark.primary};
    border-radius: ${small ? theme.decoration.radius.medium : theme.decoration.radius.sharp};
    display: flex;
    flex-direction: column;
    min-height: ${small ? 'none' : sizeHeight};
    overflow: hidden;
    padding: ${small ? theme.spaces.sp4 : theme.spaces.sp9 + ' ' + theme.spaces.sp5};
    width: 100%;
  `}
`;
exports.Icon = styled_components_1.default.div `
  ${({ theme, small }) => `
    color: ${theme.colors.build.brand.primary};
    margin-bottom: ${small ? theme.spaces.sp1 : theme.spaces.sp2};
    position: relative;
    text-align: center;
    content: "${small}";
  `}
`;
exports.Title = styled_components_1.default.div `
  ${({ theme, small }) => `
    color: ${theme.colors.build.brand.primary};
    margin-bottom: ${small ? theme.spaces.sp1 : theme.spaces.sp4};
    text-align: center;
    ${small ? theme.type.bodyLargeShortRegular : theme.type.l6}
  `}
`;
exports.Description = styled_components_1.default.div `
  ${({ theme, small }) => `
    color: ${small ? theme.colors.build.dark.light : theme.colors.build.medium.light.primary};
    margin-bottom: ${small ? theme.spaces.sp2 : theme.spaces.sp5};
    text-align: center;
    ${small ? theme.type.bodyMediumShort : theme.type.bodyLargeShortRegular}
    div p span {
      color: ${theme.colors.build.brand.primary};
    }
  `}
`;
exports.Buttons = styled_components_1.default.div `
  margin-top: auto;
  width: 100%;
`;
exports.ButtonDivisor = styled_components_1.default.div `
  ${({ theme }) => `
    color: ${theme.colors.build.light.dark};
    display: block;
    ${theme.type.bodyLargeShortRegular}
    padding: ${theme.spaces.sp4} ${theme.spaces.sp0};
    text-align: center;

    &:before{
      content: 'ou';
    }
  `}
`;
